export default __webpack_public_path__ + "static/SignageDark-0c6949a527e8c8c469ed4a8c555dfe78.png";